import { useState, useEffect, useRef } from "react";
import richPhoto from "./rich.jpeg";
import { supabase } from "./supabaseClient";

// ─── STRIPE CONFIG ───────────────────────────────────────────────────────────
const STRIPE_PK = "pk_test_51Tb0z7Fp4F5v0QWmzGHl3iqZnCVSu65RtREz4cZzgW0mlsseFscyDGlJHJ5iK74dzezaLVzZdmnKZs1pQ7syULQq009qB0pVeT";
const PRICES = {
  monthly: "price_1TmxXNFp4F5v0QWmQMO6W9vM",
  annual:  "price_1TmxXuFp4F5v0QWmbchM3V8I",
};

// ─── APP CONFIG ───────────────────────────────────────────────────────────────
const FREE_LIMIT = 5;
const ZAPIER_HOOK = "https://hooks.zapier.com/hooks/catch/27803422/4bkc3sg/";
const BOOKING = {
  rich:   "https://api.leadconnectorhq.com/widget/bookings/richard-kindel-personal-calendar-sg1yayq2a",
  tamera: "https://api.leadconnectorhq.com/widget/bookings/tamera-kindel-coaching-session",
};

// ─── THEMES ──────────────────────────────────────────────────────────────────
const THEMES = {
  men: {
    primary: "#1B3A6B", accent: "#C9A84C", bg: "#F5F7FA",
    card: "#FFFFFF", text: "#1A1A2E", soft: "#E8EDF5",
    gradient: "linear-gradient(135deg, #1B3A6B 0%, #2D5F9E 100%)",
    name: "men",
  },
  women: {
    primary: "#A0415D", accent: "#C9A84C", bg: "#FDF5F7",
    card: "#FFFFFF", text: "#2A1A1F", soft: "#F5E8ED",
    gradient: "linear-gradient(135deg, #A0415D 0%, #C97B8F 100%)",
    name: "women",
  },
};

// ─── SVG AVATARS ─────────────────────────────────────────────────────────────
const DanielAvatar = ({ size = 60, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", borderRadius: "50%", display: "block" }}>
    <circle cx="50" cy="50" r="50" fill="#1B3A6B" />
    <circle cx="50" cy="38" r="18" fill="#F5CBA7" />
    <ellipse cx="50" cy="80" rx="22" ry="16" fill="#C9A84C" />
    <rect x="36" y="54" width="28" height="22" rx="4" fill="#1B3A6B" />
    <circle cx="43" cy="36" r="2" fill="#2C1A0E" />
    <circle cx="57" cy="36" r="2" fill="#2C1A0E" />
    <path d="M44 44 Q50 49 56 44" stroke="#C0875A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M39 31 Q50 26 61 31" stroke="#5C3A1E" strokeWidth="2" fill="none" />
  </svg>
);

const SophieAvatar = ({ size = 60, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", borderRadius: "50%", display: "block" }}>
    <circle cx="50" cy="50" r="50" fill="#A0415D" />
    <circle cx="50" cy="38" r="18" fill="#F5CBA7" />
    <ellipse cx="50" cy="80" rx="22" ry="16" fill="#C9A84C" />
    <rect x="36" y="54" width="28" height="22" rx="4" fill="#A0415D" />
    <path d="M32 32 Q36 18 50 20 Q64 18 68 32 Q64 24 50 26 Q36 24 32 32Z" fill="#3D1A0A" />
    <path d="M32 32 Q28 42 34 50 Q30 44 32 32Z" fill="#3D1A0A" />
    <path d="M68 32 Q72 42 66 50 Q70 44 68 32Z" fill="#3D1A0A" />
    <circle cx="43" cy="37" r="2" fill="#2C1A0E" />
    <circle cx="57" cy="37" r="2" fill="#2C1A0E" />
    <path d="M44 45 Q50 50 56 45" stroke="#C0675A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <circle cx="38" cy="40" r="2.5" fill="#E8A598" opacity="0.6" />
    <circle cx="62" cy="40" r="2.5" fill="#E8A598" opacity="0.6" />
    <circle cx="38" cy="42" r="1.5" fill="#C9A84C" />
    <circle cx="62" cy="42" r="1.5" fill="#C9A84C" />
  </svg>
);

const RichAvatar = ({ size = 60, onClick }) => (
  <img src={richPhoto} alt="Rich Kindel" width={size} height={size} onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", borderRadius: "50%", display: "block", objectFit: "cover" }}
  />
);

const TameraAvatar = ({ size = 60, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", borderRadius: "50%", display: "block" }}>
    <circle cx="50" cy="50" r="50" fill="#6B2D82" />
    <circle cx="50" cy="38" r="18" fill="#C68642" />
    <ellipse cx="50" cy="80" rx="22" ry="16" fill="#C9A84C" />
    <rect x="36" y="54" width="28" height="22" rx="4" fill="#6B2D82" />
    <path d="M32 36 Q32 20 50 18 Q68 20 68 36 Q72 28 68 22 Q60 12 50 14 Q40 12 32 22 Q28 28 32 36Z" fill="#1A0A00" />
    <path d="M32 36 Q26 46 30 56 Q28 46 32 36Z" fill="#1A0A00" />
    <path d="M68 36 Q74 46 70 56 Q72 46 68 36Z" fill="#1A0A00" />
    <circle cx="43" cy="37" r="2" fill="#1A0A00" />
    <circle cx="57" cy="37" r="2" fill="#1A0A00" />
    <path d="M44 45 Q50 50 56 45" stroke="#8B4513" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <circle cx="37" cy="40" r="2" fill="#C9A84C" />
    <circle cx="63" cy="40" r="2" fill="#C9A84C" />
    <path d="M46 18 L48 14 L50 16 L52 14 L54 18" stroke="#C9A84C" strokeWidth="1.5" fill="none" />
  </svg>
);

// ─── COACH DATA ───────────────────────────────────────────────────────────────
const COACHES = {
  daniel: {
    name: "Coach Daniel", role: "Men's Relationship Coach",
    avatar: DanielAvatar, theme: "men",
    bio: "Coach Daniel speaks from lived experience — not theory. With decades of personal growth and real relationship work behind him, he coaches men to lead with presence, own their energy, and show up fully for the people they love. No fluff. No judgment. Just straight talk from a man who's walked the path.",
    system: `You are Coach Daniel, a warm and direct men's relationship coach for Win Together. You speak from lived experience — not theory. You are grounded, encouraging, and real.

Your coaching philosophy:
- Presence over reaction — show up fully, don't just react
- Love is a verb — texts, tell her she's beautiful, create anticipation
- Own your happiness first — you can't pour from an empty cup
- Define your role — be intentional about the man you are in this relationship
- 80/20 rule — focus on what's going right, not the 20% that isn't
- Avoid "pity city" — don't dwell, reset and move forward
- Reset, apologize, let go — don't carry yesterday into today
- Set goals together — a couple with shared vision stays connected
- Ask "advice or just listen?" — know what she needs before you respond
- Walks are valuable — movement creates conversation
- Positive energy — your energy sets the tone at home

Keep responses warm, direct, and under 150 words. No bullet lists — speak like a coach, not a textbook. Always end with one actionable thing the man can do today.`,
  },
  sophie: {
    name: "Coach Sophie", role: "Women's Relationship Coach",
    avatar: SophieAvatar, theme: "women",
    bio: "Coach Sophie combines relationship research with real perspective from a woman who has built a thriving long-term partnership. She creates a safe, honest space for women to understand themselves and their relationships more deeply — with warmth, clarity, and zero judgment.",
    system: `You are Coach Sophie, a warm and insightful women's relationship coach for Win Together. You combine relationship research with real perspective.

Your coaching philosophy:
- Your feelings are valid — and so is his perspective
- Communication is the bridge — build it before you need it
- Don't keep score — invest in the relationship, not the ledger
- Ask for what you need — he can't read your mind
- Appreciation fuels connection — catch him doing things right
- Own your energy — you set the emotional tone too
- Growth is the goal — for you, for him, for the relationship
- Presence beats perfection — show up real, not curated

Keep responses warm, direct, and under 150 words. Speak like a trusted friend who also happens to be a coach. Always end with one concrete thing she can do or say today.`,
  },
};

// ─── DAILY 3 DATA ─────────────────────────────────────────────────────────────
const DAILY3 = {
  men: [
    "Send her one specific compliment today — not 'you look nice,' but *why* she caught your eye.",
    "Ask her 'Do you need advice or do you just need me to listen?' before she starts talking.",
    "Put your phone face-down for the first 30 minutes when you're together tonight.",
  ],
  women: [
    "Tell him one thing he did this week that made you feel safe or seen.",
    "Let him solve one problem today without offering a better way.",
    "Initiate one moment of physical connection — a hug, hand on shoulder — without waiting.",
  ],
};

// ─── SUGGESTED PROMPTS ────────────────────────────────────────────────────────
const SUGGESTIONS = {
  men: [
    "Why does she shut down when we argue?",
    "How do I show up better as a partner?",
    "We keep fighting about the same things",
  ],
  women: [
    "How do I get him to open up?",
    "I feel like we've grown apart",
    "How do I bring something up without it turning into a fight",
  ],
};

// ─── TESTIMONIAL PROMPTS ──────────────────────────────────────────────────────
const TESTIMONIALS = {
  men: [
    "Why does she shut down when we argue?",
    "How do I stop the same fight from happening over and over?",
    "How do I show her I love her when words don't come easy?",
    "What do I do when she says she feels alone even though I'm right here?",
    "How do I be a better man for her without losing myself?",
    "How do I stop letting my ego get in the way of being the partner she needs?",
  ],
  women: [
    "How do I bring something up without it turning into a fight?",
    "Why does he go quiet when I need him most?",
    "How do I feel closer to him when we've been distant?",
    "How do I get him to actually hear me?",
    "How do I stop feeling like I'm the only one putting in effort?",
    "How do I work on myself when I feel like I'm losing who I am in this relationship?",
  ],
};

// ─── TESTIMONIAL STRIP (auto-scrolling) ──────────────────────────────────────
function TestimonialStrip({ items, T }) {
  const loop = [...items, ...items];
  return (
    <div style={{
      overflow: "hidden", marginBottom: 24,
      WebkitMaskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
      maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
    }}>
      <style>{`
        @keyframes wtTestimonialScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
      <div style={{ display: "flex", gap: 12, width: "max-content", animation: "wtTestimonialScroll 38s linear infinite" }}>
        {loop.map((text, i) => (
          <div key={i} style={{
            flexShrink: 0, width: 210, padding: "16px 18px", borderRadius: 14,
            background: T.soft, borderLeft: `3px solid ${T.accent}`,
            boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
          }}>
            <div style={{ color: T.primary, fontSize: 13, lineHeight: 1.6, fontWeight: 600 }}>{text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── STRIPE LOADER ────────────────────────────────────────────────────────────
const loadStripe = () =>
  new Promise((resolve) => {
    if (window.Stripe) return resolve(window.Stripe(STRIPE_PK));
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.onload = () => resolve(window.Stripe(STRIPE_PK));
    document.head.appendChild(script);
  });

// ─── STRIPE CARD FORM ────────────────────────────────────────────────────────
function StripeCardForm({ plan, email, name, onSuccess, onCancel, T }) {
  const cardRef = useRef(null);
  const cardElRef = useRef(null);
  const stripeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cardReady, setCardReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    loadStripe().then((stripe) => {
      if (!mounted || !cardRef.current) return;
      stripeRef.current = stripe;
      const elements = stripe.elements();
      const card = elements.create("card", {
        style: {
          base: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "16px",
            color: T.text,
            "::placeholder": { color: "#aab7c4" },
          },
          invalid: { color: "#fa755a" },
        },
      });
      card.mount(cardRef.current);
      cardElRef.current = card;
      card.on("ready", () => setCardReady(true));
      card.on("change", (e) => { if (e.error) setError(e.error.message); else setError(null); });
    });
    return () => { mounted = false; cardElRef.current?.destroy(); };
  }, []);

  const handlePay = async () => {
    if (!stripeRef.current || !cardElRef.current) return;
    setLoading(true);
    setError(null);
    try {
      const { paymentMethod, error: pmError } = await stripeRef.current.createPaymentMethod({
        type: "card",
        card: cardElRef.current,
        billing_details: { name, email },
      });
      if (pmError) { setError(pmError.message); setLoading(false); return; }

      const res = await fetch("/.netlify/functions/create-subscription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          paymentMethodId: paymentMethod.id,
          priceId: PRICES[plan],
          email,
          name,
        }),
      });
      const data = await res.json();
      if (data.error) { setError(data.error); setLoading(false); return; }

      // If trial, no immediate charge needed
      if (data.status === "trialing" || !data.clientSecret) {
        onSuccess(data);
        return;
      }

      // Confirm payment if needed
      const { error: confirmError } = await stripeRef.current.confirmCardPayment(data.clientSecret);
      if (confirmError) { setError(confirmError.message); setLoading(false); return; }
      onSuccess(data);
    } catch (e) {
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  const planLabel = plan === "monthly" ? "$14.99/month" : "$100/year (~$8.33/mo)";

  return (
    <div style={{ padding: "24px 20px" }}>
      <div style={{ marginBottom: 16, textAlign: "center" }}>
        <div style={{ fontSize: 13, color: T.primary, fontWeight: 700, marginBottom: 4 }}>
          {plan === "monthly" ? "Win Together" : "Annual Plan"} — 7-Day Free Trial
        </div>
        <div style={{ fontSize: 12, color: "#888" }}>Then {planLabel}. Cancel anytime.</div>
      </div>

      <div style={{
        background: T.soft, borderRadius: 12, padding: "14px 16px",
        border: `1.5px solid ${T.primary}22`, marginBottom: 16,
        minHeight: 44, opacity: cardReady ? 1 : 0.5, transition: "opacity .3s"
      }}>
        <div ref={cardRef} />
      </div>

      {error && (
        <div style={{ fontSize: 12, color: "#e53e3e", marginBottom: 12, textAlign: "center" }}>
          {error}
        </div>
      )}

      <button onClick={handlePay} disabled={loading || !cardReady} style={{
        width: "100%", padding: "14px", borderRadius: 50, border: "none",
        background: loading ? "#ccc" : T.gradient, color: "#fff",
        fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 700,
        cursor: loading ? "not-allowed" : "pointer", marginBottom: 10,
        transition: "opacity .2s",
      }}>
        {loading ? "Processing..." : "Start Free Trial →"}
      </button>

      <button onClick={onCancel} style={{
        width: "100%", padding: "10px", borderRadius: 50, border: `1.5px solid ${T.primary}44`,
        background: "transparent", color: T.primary, fontFamily: "'DM Sans', sans-serif",
        fontSize: 13, cursor: "pointer",
      }}>
        Back
      </button>

      <div style={{ textAlign: "center", marginTop: 12, fontSize: 11, color: "#aaa" }}>
        🔒 Secured by Stripe. No charges during trial.
      </div>
    </div>
  );
}

// ─── SUBSCRIPTION CHECK ───────────────────────────────────────────────────────
const checkSubscription = async (email) => {
  try {
    const res = await fetch("/.netlify/functions/check-subscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    const isPaid = data.isPaid === true;
    console.log("[checkSubscription]", email, "isPaid:", isPaid);
    return isPaid;
  } catch (err) {
    console.log("[checkSubscription] error:", err.message);
    return false;
  }
};

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
export default function WinTogether() {
  const [screen, setScreen] = useState("splash");
  const [path, setPath] = useState(null); // "men" | "women"
  const [onboardStep, setOnboardStep] = useState(0);
  const [onboardPicks, setOnboardPicks] = useState([]);
  const [lead, setLead] = useState({ name: "", email: "" });
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [msgCount, setMsgCount] = useState(0);
  const [isPaid, setIsPaid] = useState(false);
  const [showCardForm, setShowCardForm] = useState(false);
  const [avatarModal, setAvatarModal] = useState(null);
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);
  const messagesEndRef = useRef(null);
  const authHandled = useRef(false);

  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [loginEmail, setLoginEmail] = useState("");
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [journalConversations, setJournalConversations] = useState([]);
  const [journalEntry, setJournalEntry] = useState("");
  const [journalEntryId, setJournalEntryId] = useState(null);
  const [journalSaving, setJournalSaving] = useState(false);
  const [journalPastEntries, setJournalPastEntries] = useState([]);
  const [expandedConv, setExpandedConv] = useState(null);

  const T = THEMES[path || "men"];
  const coach = path === "women" ? COACHES.sophie : COACHES.daniel;
  const CoachAvatar = coach.avatar;

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    const restoreSession = (session) => {
      if (!session?.user?.email) return;
      setSession(session);
      setLead((prev) => ({ ...prev, email: session.user.email }));
      checkSubscription(session.user.email).then(setIsPaid);
      const savedPath = session.user.user_metadata?.path;
      if (savedPath) {
        setPath(savedPath);
        setScreen("home");
      } else {
        setScreen("pathSelect");
      }
    };

    // Subscribe first so onAuthStateChange can parse the URL hash token on redirect.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "INITIAL_SESSION" || event === "SIGNED_IN") {
        authHandled.current = true;
        restoreSession(session);
        setAuthLoading(false);
      }
      if (event === "SIGNED_OUT") {
        setAuthLoading(false);
      }
    });

    // getSession as a fallback for environments where INITIAL_SESSION may not fire.
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (authHandled.current) return;
      restoreSession(session);
      setAuthLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  // ── LOAD CONVERSATION ON CHAT MOUNT ──
  useEffect(() => {
    if (screen !== "chat" || !session?.user?.id) return;
    const coachKey = path === "women" ? "sophie" : "daniel";
    supabase
      .from("conversations")
      .select("id, messages")
      .eq("user_id", session.user.id)
      .eq("coach", coachKey)
      .maybeSingle()
      .then(({ data }) => {
        if (data) {
          setConversationId(data.id);
          setMessages(data.messages || []);
          setMsgCount((data.messages || []).filter((m) => m.role === "user").length);
        }
      });
  }, [screen, path, session?.user?.id]);

  // ── LOAD JOURNAL DATA ON JOURNAL MOUNT ──
  useEffect(() => {
    if (screen !== "journal" || !session?.user?.id) return;
    setJournalEntry("");
    setJournalEntryId(null);

    supabase
      .from("conversations")
      .select("id, coach, messages, updated_at")
      .eq("user_id", session.user.id)
      .order("updated_at", { ascending: false })
      .then(({ data }) => { if (data) setJournalConversations(data); });

    supabase
      .from("journal_entries")
      .select("id, body, created_at")
      .eq("user_id", session.user.id)
      .order("created_at", { ascending: false })
      .limit(10)
      .then(({ data }) => { if (data) setJournalPastEntries(data); });
  }, [screen, session?.user?.id]);

  // ── ONBOARDING QUESTIONS ──
  const ONBOARD_Q = path === "women" ? [
    { q: "What brings you here?", opts: ["Improve communication", "Rebuild trust", "Feel more connected", "Personal growth"] },
    { q: "How would you describe things right now?", opts: ["Really struggling", "A few rough patches", "Pretty good, want better", "Just exploring"] },
    { q: "What matters most to you?", opts: ["Being truly heard", "More quality time", "Emotional safety", "Shared vision"] },
  ] : [
    { q: "What brings you here?", opts: ["Improve communication", "Be a better partner", "Rebuild connection", "Personal growth"] },
    { q: "How are things at home right now?", opts: ["Really struggling", "Some tension", "Pretty good", "Just exploring"] },
    { q: "What's your biggest focus?", opts: ["Showing up more", "Managing reactions", "Quality time", "Long-term vision"] },
  ];

  // ── MAGIC LINK ──
  const sendMagicLink = async () => {
    if (!loginEmail.trim()) return;
    setLoginLoading(true);
    setLoginError(null);
    const { error } = await supabase.auth.signInWithOtp({
      email: loginEmail.trim(),
      options: { emailRedirectTo: window.location.origin },
    });
    setLoginLoading(false);
    if (error) {
      setLoginError(error.message);
    } else {
      setMagicLinkSent(true);
    }
  };

  // ── SAVE CONVERSATION ──
  const saveConversation = (msgs) => {
    if (!session?.user?.id) return;
    const coachKey = path === "women" ? "sophie" : "daniel";
    if (conversationId) {
      supabase.from("conversations").update({ messages: msgs }).eq("id", conversationId);
    } else {
      supabase
        .from("conversations")
        .insert({ user_id: session.user.id, coach: coachKey, messages: msgs })
        .select("id")
        .single()
        .then(({ data }) => { if (data) setConversationId(data.id); });
    }
  };

  // ── SIGN OUT ──
  const signOut = async () => {
    await supabase.auth.signOut();
    setSession(null);
    setPath(null);
    setOnboardStep(0);
    setOnboardPicks([]);
    setLead({ name: "", email: "" });
    setMessages([]);
    setMsgCount(0);
    setIsPaid(false);
    setConversationId(null);
  };

  // ── SAVE JOURNAL ENTRY ──
  const saveJournalEntry = async () => {
    if (!session?.user?.id || !journalEntry.trim()) return;
    setJournalSaving(true);
    if (journalEntryId) {
      await supabase.from("journal_entries").update({ body: journalEntry }).eq("id", journalEntryId);
    } else {
      const { data } = await supabase
        .from("journal_entries")
        .insert({ user_id: session.user.id, body: journalEntry })
        .select("id")
        .single();
      if (data) {
        setJournalEntryId(data.id);
        supabase
          .from("journal_entries")
          .select("id, body, created_at")
          .eq("user_id", session.user.id)
          .order("created_at", { ascending: false })
          .limit(10)
          .then(({ data: entries }) => { if (entries) setJournalPastEntries(entries); });
      }
    }
    setJournalSaving(false);
  };

  // ── SEND TO ZAPIER ──
  const sendToZapier = async (data) => {
    try {
      await fetch("/.netlify/functions/zapier", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
    } catch (_) {}
  };

  // ── AI CHAT ──
  const sendMessage = async () => {
    if (!input.trim() || aiLoading) return;
    if (!isPaid && msgCount >= FREE_LIMIT) { setScreen("paywall"); return; }

    const userMsg = { role: "user", content: input.trim() };
    const newMsgs = [...messages, userMsg];
    setMessages(newMsgs);
    setInput("");
    setMsgCount((n) => n + 1);
    setAiLoading(true);

    try {
      const res = await fetch("/.netlify/functions/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          system: coach.system,
          messages: newMsgs.map((m) => ({ role: m.role, content: m.content })),
        }),
      });
      const data = await res.json();
      const reply = data.content?.[0]?.text || "I'm here with you. Say more.";
      const finalMsgs = [...newMsgs, { role: "assistant", content: reply }];
      setMessages(finalMsgs);
      saveConversation(finalMsgs);
    } catch (_) {
      const errorMsgs = [...newMsgs, { role: "assistant", content: "Connection issue — try again in a moment." }];
      setMessages(errorMsgs);
      saveConversation(errorMsgs);
    }
    setAiLoading(false);
  };

  // ── STRIPE SUCCESS ──
  const handleSubscriptionSuccess = (data) => {
    setIsPaid(true);
    setSubscriptionSuccess(true);
    setShowCardForm(false);
    sendToZapier({ ...lead, plan: "monthly", event: "subscription_started", subscriptionId: data.subscriptionId });
    setTimeout(() => { setSubscriptionSuccess(false); setScreen("home"); }, 2500);
  };

  // ═══════════════════════════════════════════════════════
  // SCREENS
  // ═══════════════════════════════════════════════════════

  // ── AUTH LOADING ──
  if (authLoading) return (
    <div style={{ minHeight: "100dvh", background: "linear-gradient(160deg, #0F2444 0%, #1B3A6B 50%, #A0415D 100%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <style>{`@keyframes wtSpin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ width: 36, height: 36, borderRadius: "50%", border: "3px solid rgba(255,255,255,0.2)", borderTopColor: "#C9A84C", animation: "wtSpin 0.8s linear infinite" }} />
    </div>
  );

  // ── LOGIN ──
  if (!session) return (
    <div style={{ minHeight: "100dvh", background: "linear-gradient(160deg, #0F2444 0%, #1B3A6B 50%, #A0415D 100%)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 360 }}>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginBottom: 24 }}>
          <DanielAvatar size={56} />
          <SophieAvatar size={56} />
        </div>
        <div style={{ fontSize: 30, fontWeight: 800, color: "#fff", textAlign: "center", letterSpacing: -0.5, marginBottom: 6 }}>Win Together</div>
        <div style={{ fontSize: 14, color: "#C9A84C", textAlign: "center", marginBottom: 36, fontWeight: 500 }}>Relationship coaching that actually works</div>

        {!magicLinkSent ? (
          <>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#fff", marginBottom: 16, textAlign: "center" }}>Sign in to continue</div>
            <input
              type="email"
              placeholder="your@email.com"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") sendMagicLink(); }}
              style={{
                width: "100%", padding: "14px 18px", borderRadius: 12, border: "none",
                background: "rgba(255,255,255,0.95)", fontFamily: "'DM Sans', sans-serif",
                fontSize: 15, marginBottom: 12, boxSizing: "border-box", color: "#1A1A2E",
              }}
            />
            {loginError && (
              <div style={{ fontSize: 12, color: "#ff8a80", textAlign: "center", marginBottom: 12 }}>{loginError}</div>
            )}
            <button onClick={sendMagicLink} disabled={loginLoading} style={{
              width: "100%", padding: "15px", borderRadius: 50, border: "none",
              background: loginLoading ? "rgba(201,168,76,0.5)" : "linear-gradient(135deg, #C9A84C, #E8C97A)",
              color: "#1A1A2E", fontSize: 15, fontWeight: 700, cursor: loginLoading ? "not-allowed" : "pointer",
              fontFamily: "'DM Sans', sans-serif", boxShadow: "0 8px 32px rgba(201,168,76,0.3)",
            }}>
              {loginLoading ? "Sending..." : "Send Magic Link →"}
            </button>
            <div style={{ textAlign: "center", marginTop: 14, fontSize: 12, color: "rgba(255,255,255,0.4)" }}>
              No password needed — we'll email you a sign-in link.
            </div>
          </>
        ) : (
          <>
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>📬</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 10 }}>Check your email</div>
              <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
                We sent a sign-in link to<br />
                <span style={{ color: "#C9A84C", fontWeight: 600 }}>{loginEmail}</span>
              </div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 20, lineHeight: 1.7 }}>
                Click the link in your email to continue.<br />This tab will update automatically.
              </div>
            </div>
            <button onClick={() => { setMagicLinkSent(false); setLoginEmail(""); }} style={{
              width: "100%", padding: "12px", borderRadius: 50,
              border: "1.5px solid rgba(255,255,255,0.25)", background: "transparent",
              color: "rgba(255,255,255,0.7)", fontFamily: "'DM Sans', sans-serif",
              fontSize: 13, cursor: "pointer",
            }}>
              Use a different email
            </button>
          </>
        )}
      </div>
    </div>
  );

  // ── SPLASH ──
  if (screen === "splash") return (
    <div style={{ minHeight: "100dvh", background: "linear-gradient(160deg, #0F2444 0%, #1B3A6B 50%, #A0415D 100%)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
      <div style={{ marginBottom: 24, display: "flex", gap: 16 }}>
        <DanielAvatar size={70} />
        <SophieAvatar size={70} />
      </div>
      <div style={{ fontSize: 36, fontWeight: 800, color: "#fff", textAlign: "center", letterSpacing: -1, lineHeight: 1.1 }}>
        Win Together
      </div>
      <div style={{ fontSize: 15, color: "#C9A84C", marginTop: 8, marginBottom: 32, textAlign: "center", fontWeight: 500 }}>
        Relationship coaching that actually works
      </div>
      <button onClick={() => setScreen("pathSelect")} style={{
        padding: "16px 48px", borderRadius: 50, border: "none",
        background: "linear-gradient(135deg, #C9A84C, #E8C97A)",
        color: "#1A1A2E", fontSize: 16, fontWeight: 700, cursor: "pointer",
        boxShadow: "0 8px 32px rgba(201,168,76,0.4)",
      }}>
        Get Started →
      </button>
      <div style={{ marginTop: 16, fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
        5 free messages · No credit card required
      </div>
      <div style={{ marginTop: 12, fontSize: 11, color: "rgba(255,255,255,0.35)" }}>
        By <a href="https://richkindel.com" target="_blank" rel="noreferrer" style={{ color: "rgba(255,255,255,0.45)", textDecoration: "underline" }}>Rich &amp; Tamera Kindel</a>
      </div>
    </div>
  );

  // ── PATH SELECT ──
  if (screen === "pathSelect") return (
    <div style={{ minHeight: "100dvh", background: "#0F2444", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: "#fff", marginBottom: 8, textAlign: "center" }}>Who are you coaching with?</div>
      <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginBottom: 36, textAlign: "center" }}>Your coach is matched to your path</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16, width: "100%", maxWidth: 340 }}>
        {[
          { key: "men", label: "I'm a Man", sub: "Coach with Daniel", avatar: DanielAvatar, color: "#1B3A6B" },
          { key: "women", label: "I'm a Woman", sub: "Coach with Sophie", avatar: SophieAvatar, color: "#A0415D" },
        ].map(({ key, label, sub, avatar: Av, color }) => (
          <button key={key} onClick={() => {
            setPath(key);
            setScreen("onboard");
            if (session?.user?.id) supabase.auth.updateUser({ data: { path: key } });
          }} style={{
            display: "flex", alignItems: "center", gap: 16, padding: "18px 20px",
            borderRadius: 16, border: "2px solid rgba(255,255,255,0.15)",
            background: `${color}55`, cursor: "pointer", textAlign: "left",
            transition: "all .2s",
          }}>
            <Av size={52} />
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>{label}</div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)" }}>{sub}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  // ── ONBOARDING ──
  if (screen === "onboard") {
    const q = ONBOARD_Q[onboardStep];
    return (
      <div style={{ minHeight: "100dvh", background: T.gradient, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
        <div style={{ width: "100%", maxWidth: 380 }}>
          <div style={{ display: "flex", gap: 6, marginBottom: 28, justifyContent: "center" }}>
            {ONBOARD_Q.map((_, i) => (
              <div key={i} style={{ height: 4, flex: 1, borderRadius: 2, background: i <= onboardStep ? "#C9A84C" : "rgba(255,255,255,0.3)" }} />
            ))}
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#fff", marginBottom: 24, textAlign: "center" }}>{q.q}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {q.opts.map((opt) => (
              <button key={opt} onClick={() => {
                const newPicks = [...onboardPicks, opt];
                setOnboardPicks(newPicks);
                if (onboardStep < ONBOARD_Q.length - 1) {
                  setOnboardStep(onboardStep + 1);
                } else {
                  setScreen("leadCapture");
                }
              }} style={{
                padding: "14px 20px", borderRadius: 50,
                border: "2px solid rgba(255,255,255,0.4)",
                background: "rgba(255,255,255,0.12)", color: "#fff",
                fontFamily: "'DM Sans', sans-serif", fontSize: 15,
                cursor: "pointer", textAlign: "left", fontWeight: 500,
              }}>
                {opt}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // ── LEAD CAPTURE ──
  if (screen === "leadCapture") return (
    <div style={{ minHeight: "100dvh", background: T.gradient, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <CoachAvatar size={72} />
        <div style={{ fontSize: 22, fontWeight: 700, color: "#fff", marginTop: 16, marginBottom: 6 }}>
          Let's get you set up
        </div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", marginBottom: 28 }}>
          Your coach will personalize everything for you
        </div>
        <TestimonialStrip items={TESTIMONIALS[path || "men"]} T={T} />
        {["name", ...(session?.user?.email ? [] : ["email"])].map((field) => (
          <input key={field} type={field === "email" ? "email" : "text"}
            placeholder={field === "name" ? "Your first name" : "Your email"}
            value={lead[field]}
            onChange={(e) => setLead({ ...lead, [field]: e.target.value })}
            style={{
              width: "100%", padding: "14px 18px", borderRadius: 12, border: "none",
              background: "rgba(255,255,255,0.95)", fontFamily: "'DM Sans', sans-serif",
              fontSize: 15, marginBottom: 12, boxSizing: "border-box", color: "#1A1A2E",
            }}
          />
        ))}
        <button onClick={async () => {
          if (!lead.name || !lead.email) return;
          await sendToZapier({ ...lead, path, picks: onboardPicks, event: "new_lead", timestamp: new Date().toISOString() });
          setScreen("home");
        }} style={{
          width: "100%", padding: "15px", borderRadius: 50, border: "none",
          background: "linear-gradient(135deg, #C9A84C, #E8C97A)",
          color: "#1A1A2E", fontSize: 16, fontWeight: 700, cursor: "pointer", marginTop: 4,
        }}>
          Meet {coach.name} →
        </button>
      </div>
    </div>
  );

  // ── HOME ──
  if (screen === "home") return (
    <div style={{ minHeight: "100dvh", background: T.bg, fontFamily: "'DM Sans', sans-serif", paddingBottom: 80 }}>
      {/* Header */}
      <div style={{ background: T.gradient, padding: "40px 20px 24px", color: "#fff" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 4 }}>Good to see you, {lead.name || "friend"}</div>
            <div style={{ fontSize: 24, fontWeight: 700 }}>Win Together</div>
          </div>
          <button onClick={signOut} style={{
            background: "none", border: "none", color: "rgba(255,255,255,0.45)",
            fontSize: 12, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
            padding: "4px 0", marginTop: 2,
          }}>
            Sign out
          </button>
        </div>
        {!isPaid && (
          <div style={{ marginTop: 10, background: "rgba(255,255,255,0.15)", borderRadius: 8, padding: "8px 12px", fontSize: 12 }}>
            💬 {FREE_LIMIT - msgCount} free messages left · <span onClick={() => setScreen("paywall")} style={{ color: "#C9A84C", cursor: "pointer", fontWeight: 700 }}>Unlock unlimited</span>
          </div>
        )}
      </div>

      <div style={{ padding: "20px 16px", maxWidth: 480, margin: "0 auto" }}>
        {/* Coach Card */}
        <div style={{ background: T.card, borderRadius: 16, padding: 20, marginBottom: 16, display: "flex", alignItems: "center", gap: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
          <CoachAvatar size={56} onClick={() => setAvatarModal(path === "women" ? "sophie" : "daniel")} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{coach.name}</div>
            <div style={{ fontSize: 12, color: "#888", marginBottom: 8 }}>{coach.role}</div>
            <button onClick={() => setScreen("chat")} style={{
              padding: "8px 20px", borderRadius: 50, border: "none",
              background: T.gradient, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
            }}>
              Press here to start your session
            </button>
          </div>
        </div>

        {/* Daily 3 */}
        <div style={{ background: T.card, borderRadius: 16, padding: 20, marginBottom: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: T.primary, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1 }}>Today's Daily 3</div>
          {DAILY3[path || "men"].map((tip, i) => (
            <div key={i} style={{ display: "flex", gap: 12, marginBottom: i < 2 ? 12 : 0 }}>
              <div style={{ width: 26, height: 26, borderRadius: "50%", background: T.soft, color: T.primary, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{i + 1}</div>
              <div style={{ fontSize: 13, color: T.text, lineHeight: 1.5 }}>{tip}</div>
            </div>
          ))}
        </div>

        {/* Meet the Coaches */}
        <div style={{ background: T.card, borderRadius: 16, padding: 20, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: T.primary, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1 }}>Meet the Coaches</div>
          <div style={{ display: "flex", gap: 16 }}>
            {[
              { key: "rich", Avatar: RichAvatar, name: "Rich Kindel", role: "Founder" },
              { key: "tamera", Avatar: TameraAvatar, name: "Tamera Kindel", role: "Co-Founder" },
            ].map(({ key, Avatar, name, role }) => (
              <div key={key} style={{ flex: 1, textAlign: "center" }}>
                <Avatar size={52} onClick={() => setAvatarModal(key)} />
                <div style={{ fontSize: 13, fontWeight: 600, color: T.text, marginTop: 6 }}>{name}</div>
                <div style={{ fontSize: 11, color: "#888" }}>{role}</div>
                <a href={BOOKING[key]} target="_blank" rel="noreferrer" style={{
                  display: "inline-block", marginTop: 6, padding: "6px 14px",
                  borderRadius: 50, border: `1.5px solid ${T.primary}`,
                  color: T.primary, fontSize: 11, fontWeight: 600, textDecoration: "none",
                }}>Book Session</a>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 14, paddingTop: 12, borderTop: "1px solid #eee" }}>
            <a href="https://richkindel.com" target="_blank" rel="noreferrer" style={{ fontSize: 12, color: "#aaa", textDecoration: "none" }}>
              Learn more at richkindel.com →
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Nav */}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTop: "1px solid #eee", display: "flex", padding: "10px 0 16px" }}>
        {[
          { label: "Home", icon: "🏠", action: () => setScreen("home"), active: screen === "home" },
          { label: "Chat", icon: "💬", action: () => setScreen("chat"), active: screen === "chat" },
          { label: "Journal", icon: "📓", action: () => isPaid ? setScreen("journal") : setScreen("paywall"), active: screen === "journal" },
          { label: isPaid ? "✓ Pro" : "Upgrade", icon: isPaid ? "⭐" : "🔓", action: () => !isPaid && setScreen("paywall"), active: false },
        ].map(({ label, icon, action, active }) => (
          <button key={label} onClick={action} style={{
            flex: 1, background: "none", border: "none", cursor: "pointer",
            display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
            color: active ? T.primary : "#aaa", fontFamily: "'DM Sans', sans-serif",
          }}>
            <span style={{ fontSize: 20 }}>{icon}</span>
            <span style={{ fontSize: 11, fontWeight: active ? 700 : 500 }}>{label}</span>
          </button>
        ))}
      </div>

      {/* Avatar Modal */}
      {avatarModal && (() => {
        const c = avatarModal === "rich" ? { name: "Rich Kindel", role: "Founder & Men's Coach", bio: "Rich Kindel is the founder of Win Together, built from his own 25+ year marriage and a deep belief that men who show up change everything. A former college athlete, operations leader, and men's circle facilitator — Rich coaches from the real, not the ideal.", Avatar: RichAvatar, booking: BOOKING.rich }
          : avatarModal === "tamera" ? { name: "Tamera Kindel", role: "Co-Founder & Women's Coach", bio: "Tamera Kindel brings her experience as a wife, mother, and community builder to every coaching session. She's the voice behind the women's content in Win Together — unfiltered, wise, and deeply compassionate.", Avatar: TameraAvatar, booking: BOOKING.tamera }
          : avatarModal === "sophie" ? { name: "Coach Sophie", role: "AI Women's Coach", bio: COACHES.sophie.bio, Avatar: SophieAvatar }
          : { name: "Coach Daniel", role: "AI Men's Coach", bio: COACHES.daniel.bio, Avatar: DanielAvatar };
        return (
          <div onClick={() => setAvatarModal(null)} style={{ position: "fixed", top: 0, right: 0, bottom: 0, left: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "flex-end", zIndex: 100 }}>
            <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: "20px 20px 0 0", padding: "28px 24px 40px", width: "100%", maxWidth: 480, margin: "0 auto" }}>
              <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 16 }}>
                <c.Avatar size={64} />
                <div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: T.text }}>{c.name}</div>
                  <div style={{ fontSize: 13, color: "#888" }}>{c.role}</div>
                </div>
              </div>
              <p style={{ fontSize: 14, color: "#555", lineHeight: 1.7, marginBottom: 20 }}>{c.bio}</p>
              {c.booking && (
                <a href={c.booking} target="_blank" rel="noreferrer" style={{
                  display: "block", textAlign: "center", padding: "13px",
                  borderRadius: 50, background: T.gradient, color: "#fff",
                  fontWeight: 700, fontSize: 14, textDecoration: "none",
                }}>Book a Live Session</a>
              )}
            </div>
          </div>
        );
      })()}
    </div>
  );

  // ── CHAT ──
  if (screen === "chat") return (
    <div style={{ minHeight: "100dvh", background: T.bg, fontFamily: "'DM Sans', sans-serif", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ background: T.gradient, padding: "44px 16px 16px", display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={() => setScreen("home")} style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", padding: 0 }}>←</button>
        <CoachAvatar size={40} onClick={() => setAvatarModal(path === "women" ? "sophie" : "daniel")} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>{coach.name}</div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>{isPaid ? "Unlimited · Pro" : `${FREE_LIMIT - msgCount} free messages left`}</div>
        </div>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: 12 }}>
        {messages.length === 0 && (
          <div style={{ textAlign: "center", padding: "40px 20px" }}>
            <CoachAvatar size={56} />
            <div style={{ marginTop: 12, fontSize: 15, fontWeight: 600, color: T.text }}>Hey {lead.name || "there"} 👋</div>
            <div style={{ fontSize: 13, color: "#888", marginTop: 6, lineHeight: 1.6 }}>I'm {coach.name}. What's on your mind today?</div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start", gap: 8, alignItems: "flex-end" }}>
            {m.role === "assistant" && <CoachAvatar size={28} />}
            <div style={{
              maxWidth: "78%", padding: "12px 16px", borderRadius: m.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
              background: m.role === "user" ? T.gradient : "#fff",
              color: m.role === "user" ? "#fff" : T.text, fontSize: 14, lineHeight: 1.6,
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}>{m.content}</div>
          </div>
        ))}
        {aiLoading && (
          <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
            <CoachAvatar size={28} />
            <div style={{ padding: "12px 16px", borderRadius: "18px 18px 18px 4px", background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
              <span style={{ fontSize: 18, animation: "pulse 1s infinite" }}>···</span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Paywall nudge */}
      {!isPaid && msgCount >= FREE_LIMIT - 1 && msgCount < FREE_LIMIT && (
        <div style={{ margin: "0 16px 8px", background: T.soft, borderRadius: 12, padding: "12px 14px", textAlign: "center", fontSize: 13, color: T.primary, lineHeight: 1.6 }}>
          Thank you for trying out {coach.name} — they would love to continue this conversation. If you would like to unlock more and save your conversations in a journal to reference and come back to, <span onClick={() => setScreen("paywall")} style={{ fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>sign up for one of our monthly packages</span>.
        </div>
      )}

      {/* Suggested Prompts */}
      {messages.length === 0 && !(!isPaid && msgCount >= FREE_LIMIT) && (
        <div style={{ padding: "0 16px 12px", display: "flex", flexWrap: "wrap", gap: 8 }}>
          {SUGGESTIONS[path || "men"].map((s) => (
            <button key={s} onClick={() => setInput(s)} style={{
              padding: "10px 16px", borderRadius: 50,
              border: `1.5px solid ${T.primary}33`, background: T.soft,
              color: T.primary, fontFamily: "'DM Sans', sans-serif",
              fontSize: 13, fontWeight: 600, cursor: "pointer", textAlign: "left",
            }}>
              {s}
            </button>
          ))}
        </div>
      )}

      {/* Input */}
      {!isPaid && msgCount >= FREE_LIMIT ? (
        <div style={{ padding: "16px", background: "#fff", borderTop: "1px solid #eee" }}>
          <button onClick={() => setScreen("paywall")} style={{
            width: "100%", padding: "14px", borderRadius: 50, border: "none",
            background: T.gradient, color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
          }}>
            🔓 Unlock Unlimited Coaching
          </button>
        </div>
      ) : (
        <div style={{ padding: "12px 16px", background: "#fff", borderTop: "1px solid #eee", display: "flex", gap: 10 }}>
          <input value={input} onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") sendMessage(); }}
            enterKeyHint="send"
            placeholder={`Tell ${coach.name} what's on your mind...`}
            style={{
              flex: 1, padding: "12px 16px", borderRadius: 50, border: `1.5px solid ${T.soft}`,
              background: T.soft, fontFamily: "'DM Sans', sans-serif", fontSize: 14,
              outline: "none", color: T.text,
            }}
          />
          <button onClick={sendMessage} disabled={aiLoading} style={{
            width: 44, height: 44, borderRadius: "50%", border: "none",
            background: T.gradient, color: "#fff", fontSize: 18, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>→</button>
        </div>
      )}
    </div>
  );

  // ── JOURNAL ──
  if (screen === "journal") {
    const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

    return (
      <div style={{ minHeight: "100dvh", background: T.bg, fontFamily: "'DM Sans', sans-serif", paddingBottom: 80 }}>
        {/* Header */}
        <div style={{ background: T.gradient, padding: "40px 20px 24px", color: "#fff" }}>
          <div style={{ fontSize: 24, fontWeight: 700 }}>My Journal</div>
          <div style={{ fontSize: 13, opacity: 0.7, marginTop: 4 }}>Your conversations &amp; reflections</div>
        </div>

        <div style={{ padding: "20px 16px", maxWidth: 480, margin: "0 auto" }}>

          {/* ── Conversations ── */}
          <div style={{ fontSize: 13, fontWeight: 700, color: T.primary, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1 }}>
            Coach Conversations
          </div>

          {journalConversations.length === 0 ? (
            <div style={{ background: T.card, borderRadius: 16, padding: 24, textAlign: "center", color: "#aaa", fontSize: 13, marginBottom: 24, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
              No conversations yet — start chatting with your coach.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 24 }}>
              {journalConversations.map((conv) => {
                const coachData = COACHES[conv.coach];
                const CoachAv = coachData.avatar;
                const isExpanded = expandedConv === conv.id;
                const lastAssistant = [...(conv.messages || [])].reverse().find((m) => m.role === "assistant");
                const msgCount = (conv.messages || []).length;

                return (
                  <div key={conv.id} style={{ background: T.card, borderRadius: 16, overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
                    {/* Card header — always visible */}
                    <div
                      onClick={() => setExpandedConv(isExpanded ? null : conv.id)}
                      style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", cursor: "pointer" }}
                    >
                      <CoachAv size={36} />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: T.text }}>{coachData.name}</div>
                        <div style={{ fontSize: 11, color: "#aaa" }}>{fmtDate(conv.updated_at)} · {msgCount} message{msgCount !== 1 ? "s" : ""}</div>
                      </div>
                      <span style={{ fontSize: 12, color: "#bbb" }}>{isExpanded ? "▲" : "▼"}</span>
                    </div>

                    {/* Collapsed preview */}
                    {!isExpanded && lastAssistant && (
                      <div style={{ padding: "0 16px 14px", fontSize: 13, color: "#777", lineHeight: 1.5, borderTop: `1px solid ${T.soft}` }}>
                        <div style={{ paddingTop: 10, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                          {lastAssistant.content}
                        </div>
                      </div>
                    )}

                    {/* Expanded full thread */}
                    {isExpanded && (
                      <div style={{ borderTop: `1px solid ${T.soft}`, padding: "12px 16px", display: "flex", flexDirection: "column", gap: 10, maxHeight: 400, overflowY: "auto" }}>
                        {(conv.messages || []).map((m, i) => (
                          <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start" }}>
                            <div style={{
                              maxWidth: "82%", padding: "10px 14px", fontSize: 13, lineHeight: 1.6,
                              borderRadius: m.role === "user" ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                              background: m.role === "user" ? T.gradient : T.soft,
                              color: m.role === "user" ? "#fff" : T.text,
                            }}>
                              {m.content}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* ── Free Write ── */}
          <div style={{ fontSize: 13, fontWeight: 700, color: T.primary, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1 }}>
            Free Write
          </div>

          <div style={{ background: T.card, borderRadius: 16, padding: 20, marginBottom: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
            <textarea
              value={journalEntry}
              onChange={(e) => setJournalEntry(e.target.value)}
              onBlur={saveJournalEntry}
              placeholder="What's on your mind today? Write freely — this is just for you."
              style={{
                width: "100%", minHeight: 160, border: "none", outline: "none", resize: "none",
                fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: T.text,
                background: "transparent", lineHeight: 1.8, boxSizing: "border-box",
              }}
            />
            <div style={{ textAlign: "right", fontSize: 11, color: journalSaving ? T.primary : journalEntryId ? "#bbb" : "transparent", marginTop: 4 }}>
              {journalSaving ? "Saving..." : "Saved ✓"}
            </div>
          </div>

          {/* Past entries */}
          {journalPastEntries.length > 0 && (
            <>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#aaa", marginBottom: 10, textTransform: "uppercase", letterSpacing: 1 }}>
                Past Entries
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {journalPastEntries
                  .filter((e) => e.id !== journalEntryId)
                  .map((e) => (
                    <div key={e.id} style={{ background: T.card, borderRadius: 12, padding: "14px 16px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                      <div style={{ fontSize: 11, color: T.primary, fontWeight: 700, marginBottom: 6 }}>{fmtDate(e.created_at)}</div>
                      <div style={{ fontSize: 13, color: "#666", lineHeight: 1.6, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}>
                        {e.body}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>

        {/* Bottom Nav */}
        <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTop: "1px solid #eee", display: "flex", padding: "10px 0 16px" }}>
          {[
            { label: "Home", icon: "🏠", action: () => setScreen("home"), active: false },
            { label: "Chat", icon: "💬", action: () => setScreen("chat"), active: false },
            { label: "Journal", icon: "📓", action: () => setScreen("journal"), active: true },
            { label: isPaid ? "✓ Pro" : "Upgrade", icon: isPaid ? "⭐" : "🔓", action: () => !isPaid && setScreen("paywall"), active: false },
          ].map(({ label, icon, action, active }) => (
            <button key={label} onClick={action} style={{
              flex: 1, background: "none", border: "none", cursor: "pointer",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
              color: active ? T.primary : "#aaa", fontFamily: "'DM Sans', sans-serif",
            }}>
              <span style={{ fontSize: 20 }}>{icon}</span>
              <span style={{ fontSize: 11, fontWeight: active ? 700 : 500 }}>{label}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // ── PACKAGES ──
  if (screen === "paywall") {
    if (subscriptionSuccess) return (
      <div style={{ minHeight: "100dvh", background: T.gradient, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: 24 }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🎉</div>
        <div style={{ fontSize: 24, fontWeight: 800, color: "#fff", textAlign: "center" }}>You're in!</div>
        <div style={{ fontSize: 15, color: "rgba(255,255,255,0.8)", marginTop: 8, textAlign: "center" }}>Your 7-day free trial has started. Let's get to work.</div>
      </div>
    );

    const liveBooking = BOOKING[path === "women" ? "tamera" : "rich"];

    return (
      <div style={{ minHeight: "100dvh", background: T.bg, fontFamily: "'DM Sans', sans-serif" }}>
        {/* Header */}
        <div style={{ position: "relative", background: T.gradient, padding: "44px 16px 28px", textAlign: "center", color: "#fff" }}>
          <button onClick={() => setScreen("home")} style={{ position: "absolute", left: 16, top: 44, background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", padding: 0 }}>←</button>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Choose Your Package</div>
          <div style={{ fontSize: 14, opacity: 0.8, marginTop: 6 }}>Unlock more coaching, your way</div>
        </div>

        <div style={{ padding: "24px 16px", maxWidth: 420, margin: "0 auto" }}>
          {!showCardForm && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 12 }}>
              {/* Win Together */}
              <div style={{ background: T.card, borderRadius: 20, padding: 24, border: `2px solid ${T.primary}22`, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize: 13, color: T.primary, fontWeight: 700, marginBottom: 4, textTransform: "uppercase", letterSpacing: 1 }}>
                  Win Together
                </div>
                <div style={{ fontSize: 40, fontWeight: 800, color: T.text }}>
                  $14.99<span style={{ fontSize: 15, color: "#888", fontWeight: 400 }}>/mo</span>
                </div>
                <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10, textAlign: "left" }}>
                  {["Unlimited AI coaching messages", "Journal access — save & revisit your conversations"].map((f) => (
                    <div key={f} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 14, color: T.text }}>
                      <span style={{ color: T.accent, fontSize: 16 }}>✓</span> {f}
                    </div>
                  ))}
                </div>
                <button onClick={() => setShowCardForm(true)} style={{
                  width: "100%", padding: "14px", borderRadius: 50, border: "none",
                  background: T.gradient, color: "#fff", fontSize: 15, fontWeight: 700,
                  cursor: "pointer", boxShadow: `0 6px 24px ${T.primary}44`, marginTop: 18,
                }}>
                  Subscribe →
                </button>
              </div>

              {/* Win Together Pro */}
              <div style={{ background: T.card, borderRadius: 20, padding: 24, border: `2px solid ${T.accent}66`, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize: 13, color: T.accent, fontWeight: 700, marginBottom: 4, textTransform: "uppercase", letterSpacing: 1 }}>
                  Win Together Pro
                </div>
                <div style={{ fontSize: 40, fontWeight: 800, color: T.text }}>
                  $50<span style={{ fontSize: 15, color: "#888", fontWeight: 400 }}>/mo</span>
                </div>
                <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10, textAlign: "left" }}>
                  {["Everything in Win Together", "Live coaching sessions with Rich or Tamera"].map((f) => (
                    <div key={f} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 14, color: T.text }}>
                      <span style={{ color: T.accent, fontSize: 16 }}>✓</span> {f}
                    </div>
                  ))}
                </div>
                <a href={liveBooking} target="_blank" rel="noreferrer" style={{
                  display: "block", boxSizing: "border-box", width: "100%", padding: "14px", borderRadius: 50,
                  background: `linear-gradient(135deg, ${T.accent}, #E8C97A)`, color: "#1A1A2E",
                  fontSize: 15, fontWeight: 700, textAlign: "center", textDecoration: "none", marginTop: 18,
                }}>
                  Book Now →
                </a>
              </div>

              <div style={{ textAlign: "center", fontSize: 12, color: "#aaa" }}>
                7 days free on Win Together · No charges until trial ends · Cancel anytime
              </div>
            </div>
          )}

          {/* Stripe Card Form */}
          {showCardForm && (
            <div style={{ background: T.card, borderRadius: 20, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", overflow: "hidden" }}>
              <StripeCardForm
                plan="monthly"
                email={lead.email}
                name={lead.name}
                onSuccess={handleSubscriptionSuccess}
                onCancel={() => setShowCardForm(false)}
                T={T}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
}
